export default "__VITE_ASSET__0dd05309__"